/* ============================================================
   CECO Footer — acordeón de columnas en móvil (<1024px)
   En desktop el CSS las deja siempre abiertas y el head inerte.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.ceco-footer__col-head');
    if (!head) return;
    if (window.matchMedia('(min-width: 1024px)').matches) return; // desktop: no toggle
    var col = head.closest('.ceco-footer__col');
    if (!col) return;
    var open = col.classList.toggle('is-open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
